import axios from "axios";
import { APP_ACCOUNT_API_ENDPOINT } from "constants/api_urls";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAccountList } from "store/slices/account/accountSlice";
import { getUserToken } from "utils/functions/userToken";

const useGetAccountList = () => {
  const token = getUserToken();
  const { accounts = [] } = useSelector((state) => state?.account || {});
  const [accountList, setAccountList] = useState([]);
  const [hotelsList, setHotelsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      if (!accounts.length || !hotelsList.length) {
        setLoading(true);
        axios
          .get(`${APP_ACCOUNT_API_ENDPOINT}/api/accounts/list/v2`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            dispatch(updateAccountList(res?.data?.account_list))
            setAccountList(res?.data?.account_list);
            setHotelsList(res?.data?.hotel_list);
            setLoading(false);
          })
          .catch((err) => {
            console.error(err);
            setLoading(false);
          });
      }
    };

    fetchData();
  }, [JSON.stringify(accounts), token, JSON.stringify(hotelsList), dispatch]);

  return {
    accountList,
    hotelsList,
    loading,
  };
};

export default useGetAccountList;
